import Cookies from 'js-cookie'

const TokenKey = 'manage-token'

export function getToken() {
  const manageLoginInfo = JSON.parse(localStorage.getItem('manageLoginInfo')) || {}
  return manageLoginInfo.token || ''
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js